import { transform, isArray, isObject, cloneDeep, isEmpty, has } from 'lodash';

const getCleanFormValue = (
  newData = {},
  initialData = {},
  isDetectedObject = true,
  acc = {}
) => {
  if (isEmpty(newData)) {
    return initialData;
  }
  return transform(
    initialData,
    (result, val, key) => {
      if (!has(newData, key)) {
        result[key] = val;
        return;
      }
      if (isDetectedObject) {
        if (isArray(val)) {
          result[key] = getCleanFormValue(
            initialData[key],
            newData[key],
            true,
            [],
            true
          );
          return;
        }
        if (isObject(val)) {
          result[key] = getCleanFormValue(newData[key], initialData[key]);
          return;
        }
      }

      result[key] = newData[key];
    },
    acc
  );
};
const prepareFormFields = (initialValue, currentValue) => {
  if (!currentValue) {
    return cloneDeep(initialValue);
  }
  return getCleanFormValue(currentValue, cloneDeep(initialValue));
};

export default prepareFormFields